export const configureWebchat = () => {
    global._gt = global._gt || [];

    global._gt.push([
        "config",
        {
            dslResource: `${process.env.WEBCHAT_URL}/server/resources/dsl/domain-model.xml`,
            httpsEndpoint: process.env.WEBCHAT_URL,
        },
    ]);

    global._gwc = {
        autoRestore: true,
        createContact: true,
        debug: false,
        embedded: true,
        /* Callbacks */
        onReady: [],
        serverUrl: `${process.env.WEBCHAT_URL}/server/cometd`,
        templates: `${process.env.WEBCHAT_URL}/server/resources/chatTemplatesIon.html`,
        widgetUrl: `${process.env.WEBCHAT_URL}/server/resources/chatWidget.html`,
        windowName: "Chat with GoMo",
        windowOptions: { left: 0, top: 0 },
        windowSize: { width: 400, height: 500 },
    };

    ((gwcChatId) => {
        if (document.getElementById(gwcChatId)) {
            return;
        }
        const scriptTag = document.createElement("script");
        scriptTag.id = gwcChatId;
        scriptTag.src = `${process.env.WEBCHAT_URL}/server/resources/js/build/GWC.min.js`;
        scriptTag.setAttribute("data-gwc-var", gwcChatId);
        (document.getElementsByTagName("head")[0] || document.body).appendChild(scriptTag);
    })("_gwc");

    ((gpeChatId) => {
        if (document.getElementById(gpeChatId)) {
            return;
        }
        const scriptTag = document.createElement("script");
        scriptTag.id = gpeChatId;
        scriptTag.src = `${process.env.WEBCHAT_URL}/server/resources/js/build/GPE.min.js`;
        (document.getElementsByTagName("head")[0] || document.body).appendChild(scriptTag);
    })("_gt");
};

interface IIds {
    pageID: string;
    visitID: string;
}

interface IStartChat {
    registration: boolean;
    userData: IIds;
}

export const openChat = () => {
    global._gwc.onReady.push((chatAPI: { startChat(startChat: IStartChat): void }) => {
        global._gt.push([
            "getIDs",
            (ids: IIds) => {
                chatAPI.startChat({ registration: true, userData: { visitID: ids.visitID, pageID: ids.pageID } });
            },
        ]);
    });
};
